import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";

import { getIsAuthenticated } from "@skilitics/designer-auth/state";

import { useContentHostId } from "../backend/index.ts";
import { useUsageAnalyticsDataContext } from "./UsageAnalyticsDataContext.ts";

export const useUsageAnalyticsModuleVersions = () => {
  const moduleId = useContentHostId();
  const { api, moduleVersionFilterEnabled, dataAnalysisEnabled } = useUsageAnalyticsDataContext();

  const { data = [], status } = useQuery({
    queryKey: ["module-versions-data", moduleId],
    queryFn: () => api.getModuleVersions(moduleId!),
    enabled: dataAnalysisEnabled && moduleVersionFilterEnabled && getIsAuthenticated(),
    refetchOnWindowFocus: true,
  });

  return useMemo(
    () => ({
      moduleVersions: data,
      status,
    }),
    [data, status],
  );
};
